import loadable from '@loadable/component';

// Routes
import coreRoutes from '../../core/routes';

export default {
	home: coreRoutes.home,
	login: coreRoutes.login,
	eventDetail: coreRoutes.eventDetail,
	customForm: coreRoutes.customForm,
	payment: coreRoutes.payment,
	checkout: coreRoutes.checkout,
	checkoutSummary: coreRoutes.checkoutSummary,
	faq: coreRoutes.faq,
	page: coreRoutes.page,
	contact: {
		...coreRoutes.contact,
		path: '/iletisim/:branch?',
		layout: 'base',
	},
	events: coreRoutes.events,
	eventsWithLocation: coreRoutes.eventsWithLocation,
	search: coreRoutes.search,
	locationSelection: {
		path: '/sehir/:slug?',
		exact: true,
		layout: 'base',
		layoutClass: 'location-selection',
		component: loadable(
			() => import(/* webpackPrefetch: true */ '/views/pages/location-selection')
		),
	},
	menu: coreRoutes.menu,
	walletInstructions: coreRoutes.walletInstructions,
	account: coreRoutes.account,
	notFound: coreRoutes.notFound,
	error: coreRoutes.error,
};
